export const blockFeatures = () => {
  return {
    type: 'BLOCK_FEATURES'
  }
}

export const unBlockFeatures = () => {
  return {
    type: 'UNBLOCK_FEATURES'
  }
}